import { render, staticRenderFns } from "./PartnershipI.vue?vue&type=template&id=44419de4&scoped=true"
import script from "./PartnershipI.vue?vue&type=script&lang=js"
export * from "./PartnershipI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44419de4",
  null
  
)

export default component.exports